import React from 'react';
import { Card, Badge } from 'react-bootstrap';
//import './InsightsStyles.css';

const InsightsSection = ({ insights }) => {
    const hasInsights = insights && insights.length > 0;

    return (
        <Card className="insights-card shadow mb-4">
            <Card.Header className="insights-header">
                <h3 className="mb-0">
                    <span className="insights-icon">📊</span> Insights
                </h3>
            </Card.Header>

            <Card.Body>
                {hasInsights ? (
                    insights.map((insight, idx) => (
                        <Card key={idx} className="insight-item mb-3">
                            <Card.Body>
                                <div className="d-flex justify-content-between align-items-start">
                                    <h5 className="insight-category">{insight.category}</h5>
                                    <Badge bg="primary" className="insight-badge">
                                        Insight #{idx + 1}
                                    </Badge>
                                </div>
                                <p className="insight-details mt-2">{insight.details}</p>
                                <div className="insight-recommendation mt-3">
                                    <strong>Recommendation:</strong>{' '}
                                    <span className="text-success">{insight.recommendation}</span>
                                </div>
                            </Card.Body>
                        </Card>
                    ))
                ) : (
                    <div className="text-center p-4 no-insights">
                        <div className="no-insights-icon">🧐</div>
                        <h5 className="mt-2">No Insights Available</h5>
                        <p className="text-muted">We couldn't find any insights for this product</p>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default InsightsSection;
